/* Archivo: assets/visualizer-wrapper.js */

// --- 1. UTILIDADES Y CONFIGURACIÓN ---
function formatMoney(cents, format) {
  const moneyFormat = format || window.visualizerConfig.moneyFormat;
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  
  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) { return 0; }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }
  
  const match = moneyFormat.match(placeholderRegex);
  if (match === null) { return formatWithDelimiters(cents); }
  let value = '';
  switch (match[1]) {
    case 'amount': value = formatWithDelimiters(cents); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    default: value = formatWithDelimiters(cents); break;
  }
  return moneyFormat.replace(placeholderRegex, value);
}

// --- 2. INICIALIZACIÓN ---
async function initVisualizer() {
  const config = window.visualizerConfig;
  
  // IMPORTACIÓN DINÁMICA: Carga el JS específico del producto definido en Liquid
  let Product3DViewer;
  try {
      const module = await import(config.viewerScriptUrl);
      Product3DViewer = module.Product3DViewer;
  } catch (error) {
      console.error("Error cargando el script del visualizador:", error);
      return;
  }

  // DATOS
  const storeURL = config.shopUrl;
  const product = config.product;
  const firstVariant = config.firstVariant;
  const MODEL_URL = config.modelUrl;
  const ENV_URL = config.envUrl;

  const options = config.modelOptions || {};
  
  const bodyOptions = options.body || [];
  const backrestOptions = options.backrest || [];
  const seatOptions = options.seat || [];

  const allOptions = [...bodyOptions, ...backrestOptions, ...seatOptions];

  /*
  const bodyOptions = config.bodyOptions;
  const backrestOptions = config.backrestOptions;
  const seatOptions = config.seatOptions;
  const allOptions = [...bodyOptions, ...backrestOptions, ...seatOptions];
  */

  const variantSelectContainers = Array.from(document.querySelectorAll("[id^='option-']"));
  const addToCartButton = document.getElementById('add-to-cart');
  const quickBuyButton = document.getElementById('quick-buy');
  const priceText = document.querySelector('[data-price-text]');
  const addToCartContent = addToCartButton ? addToCartButton.innerHTML : '';

  // --- 3. FUNCIONES LÓGICAS ---
  function updateDropdownLabel(container) {
    const label = container.querySelector('[data-option-name-set]');
    const selectedOption = container.querySelector('.option-select.selected');
    if (label && selectedOption) {
        const cloneElement = selectedOption.querySelector('[data-variant-option]').cloneNode(true);
        label.innerHTML = cloneElement.innerHTML;
    }
  }
  
  function findVariantByOptions(selectedOptions) { return product.variants.find(variant => variant.options.every((opt, i) => opt === selectedOptions[i])); }

  function applyVariant(variant) {
    if (!variant) {
      if(addToCartButton) {
          addToCartButton.textContent = 'No disponible';
          addToCartButton.classList.add('is-inactive-button');
      }
      if(quickBuyButton) quickBuyButton.classList.add('is-inactive-button');
      if(priceText) priceText.textContent = ''; 
      return;
    }
    if(priceText) priceText.textContent = formatMoney(variant.price);
    const variantIdEl = document.querySelector('[data-variant-id]');
    if(variantIdEl) variantIdEl.setAttribute('data-variant-id', variant.id);
    
    if (variant.available) {
      if(addToCartButton) {
          addToCartButton.innerHTML = addToCartContent;
          if(addToCartButton.querySelector('[data-price-button]')) { addToCartButton.querySelector('[data-price-button]').textContent = formatMoney(variant.price); }
          addToCartButton.classList.remove('is-inactive-button');
      }
      if(quickBuyButton) quickBuyButton.classList.remove('is-inactive-button');
    } else {
      if(addToCartButton) {
          addToCartButton.textContent = 'Agotado';
          addToCartButton.classList.add('is-inactive-button');
      }
      if(quickBuyButton) quickBuyButton.classList.add('is-inactive-button');
    }
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variant.id);
    window.history.replaceState({}, "", url);
  }

  function filterDropdownOptions(dropdownIndex, selectedOptions) {
    const container = variantSelectContainers[dropdownIndex];
    if (!container) return;
    const possibleVariants = product.variants.filter(variant => selectedOptions.slice(0, dropdownIndex).every((opt, i) => opt === variant.options[i]));
    const validOptionsForThisDropdown = [...new Set(possibleVariants.map(v => v.options[dropdownIndex]))];
    container.querySelectorAll('.option-select').forEach(optionEl => {
      const optionValue = optionEl.getAttribute('data-option');
      optionEl.style.display = validOptionsForThisDropdown.includes(optionValue) ? '' : 'none';
    });
  }

  function setupEventListeners() {
    // 1. Maneja la SELECCIÓN de una opción
    document.querySelectorAll('.option-select').forEach(optionButton => {
      optionButton.addEventListener('click', function(e) {
        const wrapper = this.closest('.w-dropdown');
        const dropdownIndex = parseInt(this.closest('[data-index]').getAttribute('data-index'));

        this.parentElement.querySelectorAll('.option-select').forEach(sib => sib.classList.remove('selected'));
        this.classList.add('selected');
        updateDropdownLabel(wrapper);
        
        if (wrapper) { wrapper.dispatchEvent(new Event('w-close')); }

        const publicNameClicked = this.getAttribute('data-option');
        const optionGroupTitle = this.getAttribute('data-option-name').trim().toLowerCase();
        
        // INTERACCIÓN CON 3D VIEWER
        let match;
        if (optionGroupTitle === 'cuerpo') {
          match = bodyOptions.find(opt => opt.publicName === publicNameClicked);
          if (match) Product3DViewer.changeBody(match.internalName);
        } else if (optionGroupTitle === 'respaldo') {
          match = backrestOptions.find(opt => opt.publicName === publicNameClicked);
          if (match) Product3DViewer.changeBackrest(match.internalName);
        } else if (optionGroupTitle === 'tejidos') {
          match = seatOptions.find(opt => opt.publicName === publicNameClicked);
          if (match) Product3DViewer.changeSeat(match.internalName);
        }

        const selectedOptions = [];
        variantSelectContainers.forEach((container, i) => {
          const selectedEl = container.querySelector('.option-select.selected');
          selectedOptions[i] = selectedEl ? selectedEl.getAttribute('data-option') : null;
        });

        for (let i = dropdownIndex + 1; i < variantSelectContainers.length; i++) {
          filterDropdownOptions(i, selectedOptions);
          const nextContainer = variantSelectContainers[i];
          const currentSelectedOption = nextContainer.querySelector('.option-select.selected');
          let isCurrentSelectionStillValid = false;
          if (currentSelectedOption && currentSelectedOption.style.display !== 'none') { isCurrentSelectionStillValid = true; }

          if (!isCurrentSelectionStillValid) {
            const firstAvailableOption = nextContainer.querySelector('.option-select:not([style*="display: none"])');
            nextContainer.querySelectorAll('.option-select').forEach(opt => opt.classList.remove('selected'));
            if (firstAvailableOption) { firstAvailableOption.classList.add('selected'); }
          }
          
          const finalSelectedOption = nextContainer.querySelector('.option-select.selected');
          if (finalSelectedOption) {
              selectedOptions[i] = finalSelectedOption.getAttribute('data-option');
              updateDropdownLabel(nextContainer.querySelector('.w-dropdown'));
          } else {
              selectedOptions[i] = null;
              const nextLabel = nextContainer.querySelector('[data-option-name-set]');
              if (nextLabel) {
                  const optionName = nextLabel.getAttribute('data-option-name-set');
                  nextLabel.innerHTML = `<div>Selecciona ${optionName}</div>`;
              }
          }
        }
        if (!selectedOptions.includes(null)) {
            const currentVariant = findVariantByOptions(selectedOptions);
            applyVariant(currentVariant);
        } else {
            applyVariant(null);
        }
      });
    });

    // 2. Maneja los botones de cantidad y carrito.
    let quantity = 1;
    document.querySelectorAll('#quantity-selector .quantity-amount').forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const qty = parseInt(e.target.getAttribute('data-quantity-value'));
        if (isNaN(qty)) return;
        document.querySelector('#quantity').textContent = qty;
        quantity = qty;
        const currentVariantId = document.querySelector('[data-variant-id]').getAttribute('data-variant-id');
        const currentVariant = product.variants.find(v => v.id == currentVariantId) || firstVariant;
        if (currentVariant) {
            const totalPrice = currentVariant.price * quantity;
            const priceButtonElement = addToCartButton.querySelector('[data-price-button]');
            if (priceButtonElement) { priceButtonElement.textContent = formatMoney(totalPrice); }
        }
        e.target.closest('.w-dropdown')?.dispatchEvent(new Event('w-close'));
      });
    });
    
    if(addToCartButton) {
        addToCartButton.addEventListener('click', (e) => { e.preventDefault(); if (addToCartButton.classList.contains('is-inactive-button')) return; const variantId = document.querySelector('[data-variant-id]').getAttribute('data-variant-id') || firstVariant.id; window.Shopify.addItem(variantId, quantity, () => window.location.reload()); });
    }
    if(quickBuyButton) {
        quickBuyButton.addEventListener('click', (e) => { e.preventDefault(); if (quickBuyButton.classList.contains('is-inactive-button')) return; const variantId = document.querySelector('[data-variant-id]').getAttribute('data-variant-id') || firstVariant.id; window.location.href = `${storeURL}/cart/clear?return_to=/cart/add?items[][id]=${variantId}%26items[][quantity]=${quantity}%26return_to=/checkout`; });
    }
  }

  async function initialize3DViewerLogic() {
    const loaderContainer = document.getElementById('loader-container');
    const progressCircle = document.getElementById('progress-circle');
    
    // Aquí usamos la clase importada dinámicamente
    const config3D = {
      canvasId: 'c', modelUrl: MODEL_URL, envUrl: ENV_URL,
      onProgress: (event) => { if(progressCircle) progressCircle.style.strokeDashoffset = 314 * (1 - (event.loaded / event.total)); },
      onLoad: () => { if(loaderContainer && window.gsap) window.gsap.to(loaderContainer, { opacity: 0, duration: 0.5, onComplete: () => { loaderContainer.style.display = 'none'; }}); },
      woodTypes: bodyOptions.map(opt => opt.internalName).filter(Boolean),
      seatTypes: seatOptions
    };
    
    if(Product3DViewer && Product3DViewer.init) {
        await Product3DViewer.init(config3D);
    }
  }

  function setInitialState() {
    document.querySelectorAll('.w-dropdown-list').forEach(list => { list.style.display = ''; });
    document.querySelectorAll('.img-option').forEach($item => {
        const optionValue = $item.getAttribute('data-option-value');
        const match = allOptions.find(opt => opt.publicName === optionValue);
        if (match && match.imageUrl) { $item.setAttribute('src', match.imageUrl); $item.setAttribute('alt', match.publicName); }
    });
    const urlVariantId = new URLSearchParams(window.location.search).get("variant");
    const initialVariant = product.variants.find(v => v.id == urlVariantId) || firstVariant;
    if (initialVariant) {
        initialVariant.options.forEach((optionValue, index) => {
            const container = variantSelectContainers[index];
            if (container) {
                container.querySelectorAll('.option-select').forEach(opt => opt.classList.remove('selected'));
                const selectedOptionEl = container.querySelector(`.option-select[data-option="${optionValue}"]`);
                if(selectedOptionEl) selectedOptionEl.classList.add('selected');
            }
        });
        const selectedOptions = initialVariant.options;
        for (let i = 0; i < variantSelectContainers.length; i++) {
            filterDropdownOptions(i, selectedOptions);
            const dropdown = variantSelectContainers[i].querySelector('.w-dropdown');
            if(dropdown) updateDropdownLabel(dropdown);
        }
        applyVariant(initialVariant);
    }
    return initialVariant ? initialVariant.options : [];
  }

  // --- EJECUCIÓN ---
  const svgElement = document.querySelector('.loader-svg');
  if (svgElement && window.gsap) {
    window.gsap.to(svgElement, { rotation: 360, duration: 1, ease: 'none', repeat: -1 });
  }

  const initialSelectedOptions = setInitialState();
  setupEventListeners();
  await initialize3DViewerLogic();

  if (Product3DViewer && Product3DViewer.changeBody && initialSelectedOptions.length > 0) {
      const bodyMatch = bodyOptions.find(o => o.publicName === initialSelectedOptions[0]);
      const backrestMatch = backrestOptions.find(o => o.publicName === initialSelectedOptions[1]);
      const seatMatch = seatOptions.find(o => o.publicName === initialSelectedOptions[2]);
      if (bodyMatch) Product3DViewer.changeBody(bodyMatch.internalName);
      if (backrestMatch) Product3DViewer.changeBackrest(backrestMatch.internalName);
      if (seatMatch) Product3DViewer.changeSeat(seatMatch.internalName);
  }
}

// Ejecutar al cargar
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisualizer);
} else {
    initVisualizer();
}